import { render, staticRenderFns } from "./tokenTransfer.vue?vue&type=template&id=2723673f&scoped=true&"
import script from "./tokenTransfer.vue?vue&type=script&lang=js&"
export * from "./tokenTransfer.vue?vue&type=script&lang=js&"
import style0 from "./tokenTransfer.vue?vue&type=style&index=0&id=2723673f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2723673f",
  null
  
)

export default component.exports